import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Input, Table, Space,
} from 'antd';

import {
  FilterOutlined,
} from '@ant-design/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import styles from './index.module.scss';
import stylesLayout from '../../common/layout.module.scss';

const
  ItemsTable = ({
    items,
    onAction,
  }) => {
    const searchInput = useRef(null);

    const handleSearch = (confirm) => {
      confirm();
    };

    const handleReset = (clearFilters) => {
      clearFilters();
    };

    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({
        // eslint-disable-next-line react/prop-types
        setSelectedKeys, selectedKeys, confirm, clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={searchInput}
            placeholder="Buscar..."
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(confirm)}
              icon={<FilterOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Filtrar
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => handleReset(clearFilters)}
              style={{ width: 90 }}
            >
              Limpiar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <FilterOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) => (record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : ''),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current.select(), 100);
        }
      },
      render: (text) => text,
    });
    const columns = [
      {
        title: 'Título',
        dataIndex: 'title',
        key: 'title',
        ...getColumnSearchProps('title'),
        render: (name, r) => (
          <>
            <div
              className={`${styles.link} ${stylesLayout.link}`}
              role="button"
              tabIndex={0}
              onKeyPress={() => onAction('view', r.hash)}
              onClick={() => onAction('view', r.hash)}
            >
              {name}
            </div>
            <div className={stylesLayout.small}>{r.description}</div>
          </>
        ),
        sorter: (a, b) => (a.name < b.name ? -1 : 1),
      },
      {
        title: 'Status',
        dataIndex: 'status_tr',
        key: 'status_tr',
        align: 'center',
        ...getColumnSearchProps('status_tr'),
        render: (statusTr) => statusTr,
        sorter: (a, b) => (a.status_tr < b.status_tr ? -1 : 1),
      },
      {
        title: 'Disponible para venta',
        dataIndex: 'available_for_sell',
        key: 'available_for_sell',
        align: 'center',
        ...getColumnSearchProps('available_for_sell'),
        render: (availableForSell, r) => (
          <>
            <FontAwesomeIcon icon={availableForSell ? faCheck : faTimesCircle} style={{ color: availableForSell ? '#093' : '#c30' }} />
            {availableForSell && (
              <div>
                $
                {r.sell_price}
              </div>
            )}
          </>
        ),
        sorter: (a, b) => (a.available_for_sell < b.available_for_sell ? -1 : 1),
      },
    ];
    return (
      <div className={styles.table}>
        <Table
          rowClassName={(r) => (r.access_mail_sent_to_user ? styles.sent : '')}
          size="small"
          hideOnSinglePage
          pagination={{ defaultPageSize: 500, hideOnSinglePage: true }}
          locale={{ emptyText: 'Sin datos' }}
          columns={columns}
          dataSource={items.map((d) => ({
            key: d.id,
            typeTr: d.type_tr,
            ...d,
          }))}
        />
      </div>
    );
  };

ItemsTable.defaultProps = {
  onAction: () => { },

};

ItemsTable.propTypes = {
  items: PropTypes.array.isRequired,
  onAction: PropTypes.func,
};
export default ItemsTable;
